import React from "react";
import { Loader2 } from "lucide-react";

import styles from "./AddressAutocomplete.module.css";

const AddressResult = ({ result, index, onSelect, onLeaveTop, isLast }) => {
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      onSelect(result);
    } else if (event.key === "ArrowDown" && !isLast) {
      event.preventDefault();
      event.target.nextElementSibling?.focus();
    } else if (event.key === "ArrowUp" && index > 0) {
      event.preventDefault();
      event.target.previousElementSibling?.focus();
    } else if (event.key === "ArrowUp" && index === 0) {
      event.preventDefault();
      onLeaveTop();
    }
  };

  return (
    <div
      className={styles.result}
      data-address-result
      tabIndex={0}
      role="option"
      aria-selected="false"
      onClick={() => onSelect(result)}
      onKeyDown={handleKeyDown}
    >
      <span className={styles.resultMain}>
        {result.structured_formatting?.main_text || result.description}
      </span>
      <span className={styles.resultSecondary}>
        {result.structured_formatting?.secondary_text || result.description}
      </span>
    </div>
  );
};

/**
 * The Google Places prediction list. Nothing here writes to the form — picking a
 * result is handed back to the page, which owns the address fields.
 */
export const AddressAutocomplete = ({
  inputId,
  value,
  results,
  isSearching,
  containerRef,
  inputRef,
  onChange,
  onKeyDown,
  onSelect,
  onLeaveResults,
}) => (
  <div className={styles.container} ref={containerRef}>
    <div className={styles.inputWrap}>
      <input
        id={inputId}
        ref={inputRef}
        type="text"
        autoComplete="off"
        className={`${styles.input} ${isSearching ? styles.inputSearching : ""}`}
        placeholder="Start typing to search for an address..."
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />

      {!!isSearching && (
        <span className={styles.spinner} aria-hidden>
          <Loader2 size={16} />
        </span>
      )}
    </div>

    {results.length > 0 && (
      <div className={styles.results} role="listbox">
        {results.map((result, index) => (
          <AddressResult
            key={result.place_id}
            result={result}
            index={index}
            isLast={index === results.length - 1}
            onSelect={onSelect}
            onLeaveTop={onLeaveResults}
          />
        ))}
      </div>
    )}
  </div>
);
